import React, { Component } from 'react';
import locale from 'util/locale';
import SidebarDialog from 'ui/Dialog/SidebarDialog';
import { FormRow, FormColumn, TextInput, FormLabel } from 'ui/Form';
import { MoneyInput } from 'ui/Money';
import { connect, actions, selectors } from 'util/redux';

class TreatmentDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: { ...props.treatment },
      errors: {},
      isSaving: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.open && this.props.open) {
      this.setState({
        data: { ...this.props.treatment },
        errors: {},
      });
    }
  }

  _changeData = (field, value) => {
    const { data } = this.state;
    this.setState({
      data: {
        ...data,
        [field]: value,
      },
    });
  };

  _save = () => {
    const { createTreatment, updateTreatment, onClose } = this.props;
    const { data } = this.state;

    let save = data.id ? updateTreatment : createTreatment;

    this.setState({ isSaving: true, errors: {} });
    save(data)
      .then(() => {
        this.setState({ isSaving: false });
        onClose();
      })
      .catch(response => {
        console.error(response);
        if (response.isValidationError && response.isValidationError()) {
          this.setState({
            errors: response.validationErrors().errorPerField(),
          });
        } else {
          this.setState({
            errors: {
              _global: locale().system.global_error,
            },
          });
        }
        this.setState({ isSaving: false });
      });
  };

  render() {
    const { open, onClose } = this.props;
    const { data, errors, isSaving } = this.state;

    return (
      <SidebarDialog
        open={open}
        onClose={onClose}
        title={data.id ? locale().treatments.edit : locale().treatments.new}
        error={errors._global}
        onSave={this._save}
        inProgress={isSaving}
      >
        <FormRow>
          <FormColumn>
            <FormLabel value={locale().treatments.name} error={errors.name} />
            <TextInput
              value={data.name}
              onChange={value => this._changeData('name', value)}
            />
          </FormColumn>
        </FormRow>
        <FormRow>
          <FormColumn>
            <FormLabel
              value={`${locale().treatments.duration} (min)`}
              error={errors.duration}
            />
            <TextInput
              value={data.duration}
              onChange={value => this._changeData('duration', value)}
              type={'number'}
            />
          </FormColumn>
          <FormColumn>
            <FormLabel value={locale().treatments.price} error={errors.price} />
            <MoneyInput
              value={data.price}
              onChange={value => this._changeData('price', value)}
            />
          </FormColumn>
        </FormRow>
      </SidebarDialog>
    );
  }
}

const mapStateToProps = state => {
  return {
    treatment: selectors.getEditingTreatment(state),
    open: selectors.isEditingTreatment(state),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    createTreatment: data => dispatch(actions.createTreatment(data)),
    updateTreatment: data => dispatch(actions.updateTreatment(data)),
    onClose: () => dispatch(actions.finishTreatmentEditing()),
  };
};

TreatmentDialog = connect(mapStateToProps, mapDispatchToProps)(TreatmentDialog);

export default TreatmentDialog;
